'use client'
import store from "@/redux/store";
import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import { SelectBox } from "@/components/holders/SelectBox";

export default function StorageBaseMapSelect({...props}) {
  const [open, setOpen] = useState(true)
    let selectedStorageMap = null;
  
  
  
const handleSubmitFields = (event) => {
  event.preventDefault();
  closeModal(event);
//  var formData = new FormData(event.target);
//  let cleanFormData = Object.fromEntries(formData);

        if(props.modalOptions && props.modalOptions.action) {
            props.modalOptions.action(selectedStorageMap);
        }
    
    
    
  return false;
}

const closeModal = (event) => {
    if(props.closeModal) {
        props.closeModal();   
    }
    
}
   const setValueCombobox= (name, selected) => {
       selectedStorageMap = selected;

};  
    let storageMaps = [];
    if(props?.modalOptions?.dropbox?.maps) {
        props?.modalOptions?.dropbox?.maps.forEach((element) => {
            let option = {};
            option.name = element.name;
            option.val = element;
            storageMaps.push( option );
        });
    }

  
  return (
    <Dialog open={open} onClose={(event) => {closeModal(event)}} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform  rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-3xl sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >

    <form onSubmit={(event) => handleSubmitFields(event)}>

      <div className="space-y-12 sm:space-y-16">
        <div>
          <h2 className="text-base font-semibold leading-7 text-gray-900">Standaard map selecteren</h2>

          <div className="mt-10 space-y-8 border-b border-gray-900/10 pb-12 sm:space-y-0 sm:divide-y sm:divide-gray-900/10 sm:border-t sm:pb-0">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Map selectie
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                    <SelectBox className="" label="" name="base_map" data={storageMaps} selected={selectedStorageMap} boxfield="name" placeHolder="Selecteer een map" changeEvent={(name, val) => setValueCombobox(name,val)}/>
              </div>
            </div>
           </div>


          </div> 
        </div>


            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="submit"
                //onClick={() => confirmEvent(event)}
                className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
              >
                Toevoegen
              </button>
              <button
                type="button"
                data-autofocus
                onClick={(event) => closeModal(event)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Annuleer
              </button>
            </div>
       </form>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}